import SlimSelect from 'slim-select'

const initVehicleSelector = async () => {
    const { Theme } = window;
    const vehicleSelector = document.querySelector<HTMLElement>("#vehicle-selector");
    const manufacturerSelector = document.querySelector<HTMLElement>("#vehicle-manufacturer");
    const vehiclePopularGroup = manufacturerSelector?.querySelector<HTMLElement>('[data-id="popular"]');
    const vehicleAllGroup = manufacturerSelector?.querySelector<HTMLElement>('[data-id="all"]');
    const modelSelector = document.querySelector<HTMLElement>("#vehicle-model");
    const engineSelector = document.querySelector<HTMLElement>("#vehicle-engine");
    var slimSelectManufacturer: SlimSelect | null = null;
    var slimSelectModel: SlimSelect | null = null;
    var slimSelectEngine: SlimSelect | null = null;
    var vehicleSelectionClearButton = document.querySelector<HTMLElement>("#clearVehicleSelection");

    async function loadManufacturers(url: string, firstLoad = false) {

        const datas = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json, text/javascript, */*; q=0.01',
            },
        });

        const jsonDatas = await datas.json();
        if (jsonDatas) {
            Object.keys(jsonDatas['popular']).forEach(key => {
                let newOption = document.createElement('option');
                newOption.value = key;
                newOption.text = jsonDatas['popular'][key];
                vehiclePopularGroup?.appendChild(newOption);
            });

            //save with "all" group
            Object.keys(jsonDatas['all']).forEach(key => {
                let newOption = document.createElement('option');
                newOption.value = key;
                newOption.text = jsonDatas['all'][key];
                vehicleAllGroup?.appendChild(newOption);
            });
        }

        if(manufacturerSelector?.dataset?.selected){
            (manufacturerSelector as HTMLSelectElement).value = manufacturerSelector.dataset.selected;
            let modelsUrl = <string>vehicleSelector!.dataset.modelsurl;
            loadModels(modelsUrl, manufacturerSelector.dataset.selected);
        }
    }
    
    async function loadModels(url: string, manufacturerId: string) {

        
        var newSlimData: { text: any; value: string; }[] = [
            { text: "Pasirinkite modelį", value: "" }
        ];
        //update slim select with new data
        slimSelectModel?.setData(newSlimData);
        //clear engine selector
        var newSlimEngineData: { text: any; value: string; }[] = [
            { text: "Pasirinkite variklį", value: "" }
        ];
        //update slim select with new data
        slimSelectEngine?.setData(newSlimEngineData);
            
        //if no manufacturerId is provided, emty the model and engine selectors
        if(!manufacturerId) {
            
            return;
        }
        //clear old children
        modelSelector?.querySelectorAll('option:not([data-id="selector"])').forEach(option => { option.remove() });
        
        const datas = await fetch(url+"&params[manufacturer]="+manufacturerId, {
            method: 'GET',
            headers: {
                Accept: 'application/json, text/javascript, */*; q=0.01',
            },
        });

        const jsonDatas = await datas.json();
        if (jsonDatas) {
            var newSlimData: { text: any; value: string; }[] = [
                { text: "Pasirinkite modelį", value: "" }
            ];
            Object.keys(jsonDatas).forEach(key => {
                //let newOption = document.createElement('option');
                //newOption.value = key;
                //newOption.text = jsonDatas[key];
                //modelSelector?.appendChild(newOption);
                newSlimData.push({
                    text: jsonDatas[key],
                    value: key,
                });
                
            });
            //update slim select with new data
            slimSelectModel?.setData(newSlimData);
        }
        
        if(modelSelector?.dataset?.selected){
            (modelSelector as HTMLSelectElement).value = modelSelector.dataset.selected;
            slimSelectModel?.setSelected(modelSelector.dataset.selected);
            //clear selected model
            modelSelector.dataset.selected = "";
            let enginesUrl = <string>vehicleSelector!.dataset.enginesurl;
            loadEngines(enginesUrl, modelSelector.dataset.selected);
        }
        
        
        
    }
    
    
    async function loadEngines(url: string, modelId: string) {

        if(!modelId && !engineSelector?.dataset.selected) {
            var newSlimData: { text: any; value: string; }[] = [
                { text: "Pasirinkite variklį", value: "" }
            ];
            //update slim select with new data
            slimSelectEngine?.setData(newSlimData);
            return;
        }
        if(!url) {
            console.warn("No engines URL provided for vehicle selector.");
            return;
        }
        if(!modelId) {
            return;
        }
        //clear old children
        engineSelector?.querySelectorAll('option:not([data-id="selector"])').forEach(option => { option.remove() });
        
        const datas = await fetch(url+"&params[model]="+modelId, {
            method: 'GET',
            headers: {
                Accept: 'application/json, text/javascript, */*; q=0.01',
            },
        });

        const jsonDatas = await datas.json();

        if (jsonDatas) {
            
            var newSlimData: { text: any; value: string; }[] = [
                { text: "Pasirinkite variklį", value: "" }
            ];
            for(let val of jsonDatas){
                /*let newOption = document.createElement('option');
                newOption.value = val.slug;
                newOption.text = val.name;
                engineSelector?.appendChild(newOption);*/
                
                newSlimData.push({
                    text: val.name,
                    value: val.slug,
                });
            };
            //update slim select with new data
            slimSelectEngine?.setData(newSlimData);
        }
        
        if(engineSelector?.dataset?.selected){
            (engineSelector as HTMLSelectElement).value = engineSelector.dataset.selected;
            slimSelectEngine?.setSelected(engineSelector.dataset.selected);
            //clear selected engine
            engineSelector.dataset.selected = "";
            console.log("Selected engine: ", engineSelector.dataset.selected);
        }
    }
    if(!vehicleSelector) return;
    
    
    var slimLocation = document.querySelector<HTMLElement>("body");
    const vehicleSelectorModal = document.querySelector<HTMLElement>("#vehicleSelectorModal");
    if(vehicleSelectorModal){
        slimLocation = vehicleSelectorModal;
    }
    //init slim select
    slimSelectManufacturer = new SlimSelect({
        select: "#vehicle-manufacturer",
        
        settings: {
            searchText: "Ieškoti",
            placeholderText: "Pasirinkite markę",
            ariaLabel: "Pasirinkite markę",
            searchPlaceholder: "Ieškoti markės",
            //contentPosition: 'absolute',
            contentLocation: slimLocation,
        }
        
    });
    slimSelectModel = new SlimSelect({
        select: "#vehicle-model",
        
        settings: {
            placeholderText: "Ieškoti",
            searchPlaceholder: "Ieškoti modelio",
            contentLocation: slimLocation,
        }
    });
    slimSelectEngine = new SlimSelect({
        select: "#vehicle-engine",
        settings: {
            placeholderText: "Ieškoti",
            searchPlaceholder: "Ieškoti variklio",
            contentLocation: slimLocation,
        }
        //dropdownParent: vehicleSelector // Ensures dropdown is inside the vehicle selector
    });
    //remove .form-select classes from the select elements to avoid bootstrap styles
    manufacturerSelector?.classList.remove('form-select');
    modelSelector?.classList.remove('form-select');
    engineSelector?.classList.remove('form-select');
    let vehUrl = <string>vehicleSelector!.dataset.vehiclesurl;
    
    
    async function initEventListeners(vehicleSelector: HTMLElement) {
        
        

        manufacturerSelector?.addEventListener('change', (event) => {
            const option = event.target as HTMLOptionElement;
            let modelsUrl = <string>vehicleSelector!.dataset.modelsurl;
            console.log("manufacturer change event");
            //unset selected model and engine
            //modelSelector!.dataset.selected = "";
            //engineSelector!.dataset.selected = "";
            loadModels(modelsUrl, option.value);
        });
        
        modelSelector?.addEventListener('change', (event) => {
            const option = event.target as HTMLOptionElement;
            let enginesUrl = <string>vehicleSelector!.dataset.enginesurl;
            //engineSelector!.dataset.selected = "";
            console.log("model change event");
            loadEngines(enginesUrl, option.value);
        });
    }
    
    
    
    
    vehicleSelector.querySelector('form')?.addEventListener('submit', async (event) => {
        event.preventDefault();
        
        var errorMessage = vehicleSelector.querySelector('.error-missing-fields') as HTMLElement;
        errorMessage.classList.add('d-none');
        //check if all fields are selected
        const vehicleBrand = (vehicleSelector.querySelector('#vehicle-manufacturer') as HTMLSelectElement).value;
        const vehicleModel = (vehicleSelector.querySelector('#vehicle-model') as HTMLSelectElement).value;
        const vehicleEngine = (vehicleSelector.querySelector('#vehicle-engine') as HTMLSelectElement).value;
        
        const form = event.target as HTMLFormElement;
        const formData = new FormData(form);
        var urlTo = ""+form.getAttribute('action');
        
        if(!vehicleBrand){
            urlTo += "/reset?is_ajax=1";
            //reset the vehicle selection by calling /catalog/reset in AJAX
            fetch(urlTo, {
                method: 'GET',
            }).then((response) => {
                console.log("Vehicle selection reset.");
                
                //if URL contains "/catalog" - redirect to home page. Otherwise, reload the page
                if(window.location.href.includes("/catalog")) {
                    window.location.href = "/";
                }
                else {
                    window.location.reload();
                }
            });

            
        }
        if(vehicleBrand && (!vehicleModel || !vehicleEngine)) {
            errorMessage.classList.remove('d-none');
            return;
        }
        
        
        urlTo += "/"+formData.get('vehicle-brand');
        urlTo += "/"+formData.get('vehicle-model');
        urlTo += "/"+formData.get('vehicle-engine');
        
        var returnUrl = formData.get('return-url') as string;
        
        //hide .text inside the button and show the spinner 
        const button = form.querySelector('button[type="submit"]') as HTMLButtonElement;
        const textSpan = button.querySelector('.text') as HTMLSpanElement;
        const spinner = button.querySelector('.spinner-border') as HTMLSpanElement;
        textSpan.classList.add('d-none');
        spinner.classList.remove('d-none');
        console.log("Submitting vehicle selection: ", urlTo, " Return URL: ", returnUrl);
        
        //submit form and redirect to the urlTo
        fetch(urlTo, {
            method: 'GET',
        }).then((response) => {
            console.log("Vehicle selection submitted.");
            if(!returnUrl){
                returnUrl = urlTo;
            }
            
            //set the url to the vehicle selector
            window.location.href = returnUrl;
        }).catch((error) => {
            console.error("Error submitting vehicle selection: ", error);
        });
        
        
        
    });

    
    if(vehicleSelectorModal) {
        var vehicleSelectorModalFirstLoad = true;
        const moveSlimSelectDropdowns = () => {
            // Move all .ss-main elements that are not already inside the modal
            document.querySelectorAll('.ss-content').forEach(ssMain => {
                if (!vehicleSelectorModal.contains(ssMain)) {
                    vehicleSelectorModal.appendChild(ssMain);
                }
            });
        };

        // On modal show, move the dropdowns
        vehicleSelectorModal.addEventListener('show.bs.modal', async () => {
            moveSlimSelectDropdowns();
            //loadManufacturers(vehUrl);
            vehicleSelector.dataset.isVisible = "1";
            await loadManufacturers(vehUrl, true);
            if(vehicleSelectorModalFirstLoad) {
                initEventListeners(vehicleSelector);
                vehicleSelectorModalFirstLoad = false;
            }
            
        });
        
        //on modal hide, reset the vehicle selector
        vehicleSelectorModal.addEventListener('hide.bs.modal', () => {
            //reset the vehicle selector
            vehicleSelector.dataset.isVisible = "0";
            //clear the select elements
            (manufacturerSelector as HTMLSelectElement).value = "";
            (modelSelector as HTMLSelectElement).value = "";
            (engineSelector as HTMLSelectElement).value = "";
            //reset the slim selects
            slimSelectModel?.setData([]);
            slimSelectEngine?.setData([]);
            
            //if there are originalselected values, set them back to selected
            if(manufacturerSelector?.dataset?.originalselected) {
                (manufacturerSelector as HTMLSelectElement).dataset.selected = manufacturerSelector.dataset.originalselected;
            }
            if(modelSelector?.dataset?.originalselected) {
                console.log("Setting model selector to original selected: ", modelSelector.dataset.originalselected);
                (modelSelector as HTMLSelectElement).dataset.selected = modelSelector.dataset.originalselected;
            }
            if(engineSelector?.dataset?.originalselected) {
                (engineSelector as HTMLSelectElement).dataset.selected = engineSelector.dataset.originalselected;
            }
            
            //hide error message
            const errorMessage = vehicleSelector.querySelector('.error-missing-fields') as HTMLElement;
            errorMessage.classList.add('d-none');
        });
    }else{
        
        let vehUrl = <string>vehicleSelector!.dataset.vehiclesurl;
        //if(vehicleSelector?.dataset.isVisible != "0"){
            await loadManufacturers(vehUrl, true);
            
            initEventListeners(vehicleSelector);
        //}
    }
    
    //clear vehicle selection button
    vehicleSelectionClearButton?.addEventListener('click', (event) => {
        event.preventDefault();
        //clear the select elements
        (manufacturerSelector as HTMLSelectElement).value = "";
        (modelSelector as HTMLSelectElement).value = "";
        (engineSelector as HTMLSelectElement).value = "";
        //reset the slim selects
        slimSelectManufacturer?.setData([]);
        slimSelectModel?.setData([]);
        slimSelectEngine?.setData([]);
    });
    

    // If on the home page, hijack the modal trigger button to scroll to #vehicle-selector instead
    if(document.body.getAttribute('id') =='index'){
        const modalTriggerBtns = document.querySelectorAll<HTMLElement>('button[data-bs-target="#vehicleSelectorModal"]');
        
        for(let i=0; i<modalTriggerBtns.length; i++){
            const modalTriggerBtn = modalTriggerBtns[i];
            if (modalTriggerBtn && !vehicleSelectorModal) {
                //remove data-bs-toggle
                modalTriggerBtn.dataset.bsToggle = "";
                modalTriggerBtn.dataset.bsTarget = "";
                modalTriggerBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const selector = document.getElementById('vehicle-selector');
                    if (selector) {
                        selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        
                        //if button has close parent with class ".offcanvas" trigger close event by clicking .btn-close inside the offcanvas
                        const offcanvas = modalTriggerBtn.closest('.offcanvas');
                        if(offcanvas) {
                            const offcanvasCloseBtn = offcanvas.querySelector('.btn-close') as HTMLElement;
                            if(offcanvasCloseBtn) {
                                offcanvasCloseBtn.click();
                            }
                        }
                    }
                });
            }
        }
    }
    
    
};

export default initVehicleSelector;